/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const ko_settings_debug_fetchingemail1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 정보 조회 중...`)
};

const en_settings_debug_fetchingemail1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fetching email information...`)
};

const ja_settings_debug_fetchingemail1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メール情報を取得中...`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "ko" | "en" | "ja" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const settings_debug_fetchingemail1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_debug_fetchingemail1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_debug_fetchingemail1", locale)
	if (locale === "ko") return ko_settings_debug_fetchingemail1(inputs)
	if (locale === "en") return en_settings_debug_fetchingemail1(inputs)
	return ja_settings_debug_fetchingemail1(inputs)
};
export { settings_debug_fetchingemail1 as "settings_debug_fetchingEmail" }